import styled from '@emotion/styled';
import LongText from '__components/Inputs/LongText';

export const StyledLabel = styled.span`
  display: flex;
  gap: 5px;
  font-size: inherit;
  width: fit-content;
`;

export const StyledAIButtonWrapper = styled.div`
  height: 14px;
  & button {
    height: 14px;
    pointer-events: auto;
  }
`;

export const StyledLongText = styled(LongText)`
  & > label {
    pointer-events: none;
  }
`;
